/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Dropdown, Label, Icon
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';

class NewPolicyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCP: props.isOpenMCP,
      isLoader: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      editSearchComponent: '',
      selectedCoverage: 'project',
      policyName: '',
      policyNameError: '',
      description: '',
      category: 'component',
      componentList: [],
      versionList: [],
      riskList: [],
      licenseNameList: [],
      selectedComponent: '',
      selectedVersion: [],
      selectedVersionList: [],
      selectedCondition: 'all',
      selectedSecurity: 'severity',
      selectedSeverity: ['critical'],
      selectedRisk: [],
      selectedlicenseName: [],
      selectedLicense: 'family',
      selectedFamily: ['protective'],
      selectedLitigator: [],
      selectedPolicy: [],
      selectedPolicyError: '',
      limit: 25,
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleComponentChange = this.handleComponentChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleRemoveCondition = this.handleRemoveCondition.bind(this);
    this.handleComponentSearchChange = this.handleComponentSearchChange.bind(this);
    this.handleVersionSearchChange = this.handleVersionSearchChange.bind(this);
    this.handleCoverageChange = this.handleCoverageChange.bind(this);
    this.handleVersionConditionChange = this.handleVersionConditionChange.bind(this);
    this.handleSecurityConditionChange = this.handleSecurityConditionChange.bind(this);
    this.handleSeverityChange = this.handleSeverityChange.bind(this);
    this.handleRiskChange = this.handleRiskChange.bind(this);
    this.handleRiskSearchChange = this.handleRiskSearchChange.bind(this);
    this.handleLicenseConditionChange = this.handleLicenseConditionChange.bind(this);
    this.handleFamilyChange = this.handleFamilyChange.bind(this);
    this.handleLicenseNameChange = this.handleLicenseNameChange.bind(this);
    this.handleLicenseNameSearchChange = this.handleLicenseNameSearchChange.bind(this);
    this.handleLitigatorConditionChange = this.handleLitigatorConditionChange.bind(this);
    this.handleAddCondition = this.handleAddCondition.bind(this);
    this.handleAddSecurity = this.handleAddSecurity.bind(this);
    this.handleAddLicense = this.handleAddLicense.bind(this);
    this.handleAddLitigator = this.handleAddLitigator.bind(this);
    this.closeNewPolicyModal = this.closeNewPolicyModal.bind(this);
    this.clearVersionValue = this.clearVersionValue.bind(this);
    this.clearLitigatorValue = this.clearLitigatorValue.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { isOpenMCP } = this.props;

    if (prevState.category !== this.state.category) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedPolicy: [],
        selectedPolicyError: '',
      });
    }

    if (prevState.selectedCondition !== this.state.selectedCondition || prevState.selectedComponent !== this.state.selectedComponent) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedVersion: [],
        versionList: [],
      });
    }

    if (prevState.selectedSecurity !== this.state.selectedSecurity) {
      if (this.state.selectedSecurity === 'code') {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedSeverity: [],
        });
      } else {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedRisk: [],
          riskList: [],
        });
      }
    }

    if (prevState.selectedLicense !== this.state.selectedLicense) {
      if (this.state.selectedLicense === 'name') {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedFamily: [],
        });
      } else {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          //selectedLicenseName: [],
          licenseNameList: [],
        });
      }
    }

    if (prevProps.isOpenMCP !== isOpenMCP) {
      this.setState({
        isOpenMCP,
        isLoader: false,
        modalAlertMsg: '',
        modalAlertTitle: '',
        modalAlert: false,
        editSearchComponent: '',
        selectedCoverage: 'project',
        policyName: '',
        policyNameError: '',
        description: '',
        category: 'component',
        componentList: [],
        versionList: [],
        riskList: [],
        licenseNameList: [],
        selectedComponent: '',
        selectedVersion: [],
        selectedVersionList: [],
        selectedCondition: 'all',
        selectedSecurity: 'severity',
        selectedSeverity: ['critical'],
        selectedRisk: [],
        selectedlicenseName: [],
        selectedLicense: 'family',
        selectedFamily: ['protective'],
        selectedLitigator: [],
        selectedPolicy: [],
        selectedPolicyError: '',
      });
    }
  }

  handleCoverageChange(e, data) {
    this.setState({
      selectedCoverage: data.value,
    });
  }

  handleNameChange(e) {
    this.setState({
      policyName: e.target.value,
      policyNameError: '',
    });
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
    });
  }

  handleCategoryChange = (e) => {
    const { translate } = this.props;
    let newValue;
    switch (true) {
    case e.target.text.indexOf(translate('project.menu.component')) > -1:
      newValue = 'component';
      break;
    case e.target.text.indexOf(translate('project.menu.security')) > -1:
      newValue = 'security';
      break;
    case e.target.text.indexOf(translate('project.menu.license')) > -1:
      newValue = 'license';
      break;
    case e.target.text.indexOf(translate('project.menu.litigator')) > -1:
      newValue = 'litigator';
      break;
    default:
      newValue = 'component';
      break;
    }
    this.setState({
      category: newValue,
      selectedComponent: '',
      selectedCondition: 'all',
      selectedSecurity: 'severity',
      selectedSeverity: ['critical'],
      selectedLicense: 'family',
      selectedFamily: ['protective'],
      selectedVersion: [],
      selectedVersionList: [],
      selectedRisk: [],
      selectedlicenseName: [],
      selectedLitigator: [],
      selectedPolicy: [],
      selectedPolicyError: '',
    });
  };

  handleComponentChange = (e, { value }) => {
    const sanitizedSearchQuery = value.replace(/\/\//g, '').toLowerCase();
    this.setState({
      selectedComponent: sanitizedSearchQuery,
      selectedCondition: 'all',
      selectedVersion: '',
      selectedVersionList: [],
    });
  };

  handleComponentSearchChange = this.debounce((e, { searchQuery }) => {
    if (!searchQuery) {
      return;
    }
    const sanitizedSearchQuery = searchQuery.replace(/\/\//g, '').toLowerCase();
    this.setState({ componentList: [] }, () => {
      this.searchPolicyComponent(sanitizedSearchQuery);
    });
  }, 1000);

  handleVersionChange = (e, { value }) => {
    const { selectedVersionList, selectedCondition } = this.state;
    if (selectedCondition === 'specific') {
      if (selectedVersionList.indexOf(value) > -1) {
        return false;
      }
      const newState = [...selectedVersionList, value];
      this.setState({
        selectedVersionList: newState,
        selectedVersion: [],
      });
    } else {
      this.setState({
        selectedVersion: [value],
      });
    }
  };

  handleVersionSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ versionList: [] }, () => {
      this.searchPolicyVersion(searchQuery);
    });
  }, 1000);

  handleVersionConditionChange = (e, { value }) => {
    this.setState({
      selectedCondition: value,
      selectedVersion: '',
      selectedVersionList: [],
    });
  };

  handleSecurityConditionChange = (e, { value }) => {
    this.setState({
      selectedSecurity: value,
      selectedRisk: [],
    });
  };

  handleSeverityChange = (e, { value }) => {
    this.setState({
      selectedSeverity: [value],
    });
  };

  handleRiskChange = (e, { value }) => {
    this.setState({
      selectedRisk: [value],
    });
  };

  handleRiskSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ riskList: [] }, () => {
      this.searchPolicyRisk(searchQuery);
    });
  }, 1000);

  handleLicenseConditionChange = (e, { value }) => {
    this.setState({
      selectedLicense: value,
    });
  };

  handleFamilyChange = (e, { value }) => {
    this.setState({
      selectedFamily: [value],
    });
  };

  handleLicenseNameChange = (e, { value }) => {
    this.setState({
      selectedlicenseName: [value],
    });
  };

  handleLicenseNameSearchChange = this.debounce((e, { searchQuery }) => {
    this.setState({ licenseNameList: [] }, () => {
      this.searchPolicyLicense(searchQuery);
    });
  }, 1000);

  handleLitigatorConditionChange = (e, { value }) => {
    this.setState({
      selectedLitigator: [value],
    });
  };

  handleRemoveVersionValue = (index, value) => {
    const { selectedPolicy } = this.state;

    const updatedIndex = selectedPolicy[index].selected_version.findIndex((item) => {
      return item === value;
    });

    const updatedData = Update(selectedPolicy[index], {
      selected_version: {
        $splice: [[updatedIndex, 1]],
      },
    });

    const newData = Update(selectedPolicy, {
      $splice: [[index, 1, updatedData]],
    });

    this.setState({
      selectedPolicy: newData,
      selectedPolicyError: '',
    });
  };

  handleRemoveCondition = (index) => {
    const { selectedPolicy } = this.state;
    this.setState({
      selectedPolicy: Update(
        selectedPolicy,
        {
          $splice: [[index, 1]],
        }
      ),
      selectedPolicyError: '',
    });
  };

  handleSave(e) {
    e.preventDefault();
    const {
      policyName,
      description,
      category,
      selectedCoverage,
      selectedPolicy,
    } = this.state;
    const { translate } = this.props;

    const formData = {
      coverage: selectedCoverage,
      category,
      name: policyName,
      description,
      condition: selectedPolicy,
    };
    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api.createPolicy(formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('settings.message.update_policy'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-563') {
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('settings.message.limit_company_policy'),
          });
        }
        if (o.error === '422-564') {
          if (this.state.category === 'component') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_comapy_policy_component'),
            });
          }
          if (this.state.category === 'security') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_security'),
            });
          }
          if (this.state.category === 'license') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_license'),
            });
          }
          if (this.state.category === 'litigator') {
            this.setState({
              modalAlertMsg: translate('settings.message.limit_company_policy_litigator'),
            });
          }
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
          });
        }
        if (o.error === '422-562') {
          return this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('settings.message.duplicated_policy_name'),
          });
        }
        if (o.error_description) {
          this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            //isLoading: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  handleAddCondition() {
    const {
      selectedComponent, selectedCondition, selectedVersion, selectedVersionList, selectedPolicy
    } = this.state;
    const { translate } = this.props;

    let newObj;
    if (selectedCondition !== 'specific') {
      newObj = {
        component: selectedComponent,
        version_condition: selectedCondition,
        selected_version: selectedVersion,
      };
      if (selectedCondition === 'all') {
        const checkUnique = this.state.selectedPolicy.filter((item) => {
          return item.component === selectedComponent;
        });
        if (checkUnique.length === 0) {
          this.setState({
            selectedPolicy: [...selectedPolicy, newObj],
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            selectedPolicyError: '',
          });
        } else {
          this.setState({
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            selectedPolicyError: translate('settings.message.use_condition'),
          }, () => {
            setTimeout(() => {
              this.setState({
                selectedPolicyError: '',
              });
            }, 1500);
          });
        }
      } else {
        const checkUnique = this.state.selectedPolicy.filter((item) => {
          return item.component === selectedComponent && item.version_condition === selectedCondition && item.selected_version[0] === selectedVersion[0];
        });
        if (checkUnique.length === 0) {
          this.setState({
            selectedPolicy: [...selectedPolicy, newObj],
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            selectedPolicyError: '',
          });
        } else {
          this.setState({
            selectedComponent: '',
            selectedCondition: 'all',
            selectedVersionList: [],
            selectedVersion: [],
            selectedPolicyError: translate('settings.message.use_condition'),
          }, () => {
            setTimeout(() => {
              this.setState({
                selectedPolicyError: '',
              });
            }, 1500);
          });
        }
      }
    } else {
      newObj = {
        component: selectedComponent,
        version_condition: selectedCondition,
        selected_version: selectedVersionList,
      };

      const checkUnique = this.state.selectedPolicy.filter((item) => {
        return item.component === selectedComponent && this.isEqual(item.selected_version, selectedVersionList);
      });

      if (checkUnique.length === 0) {
        this.setState({
          selectedPolicy: [...selectedPolicy, newObj],
          selectedComponent: '',
          selectedCondition: 'all',
          selectedVersionList: [],
          selectedVersion: [],
          selectedPolicyError: '',
        });
      } else {
        this.setState({
          selectedComponent: '',
          selectedCondition: 'all',
          selectedVersionList: [],
          selectedVersion: [],
          selectedPolicyError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              selectedPolicyError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddSecurity() {
    const {
      selectedSecurity, selectedSeverity, selectedRisk, selectedPolicy
    } = this.state;
    const { translate } = this.props;
    let newObj;

    if (selectedSecurity === 'severity') {
      const checkUnique = this.state.selectedPolicy.filter((item) => {
        return item.selected[0] === selectedSeverity[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          security_condition: selectedSecurity,
          selected: selectedSeverity,
        };
        this.setState({
          selectedPolicy: [...selectedPolicy, newObj],
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          selectedPolicyError: '',
        });
      } else {
        this.setState({
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          selectedPolicyError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              selectedPolicyError: '',
            });
          }, 1500);
        });
      }
    } else {
      const checkUnique = this.state.selectedPolicy.filter((item) => {
        return item.selected[0] === selectedRisk[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          security_condition: selectedSecurity,
          selected: selectedRisk,
        };
        this.setState({
          selectedPolicy: [...selectedPolicy, newObj],
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          selectedPolicyError: '',
        });
      } else {
        this.setState({
          selectedSecurity: 'severity',
          selectedSeverity: ['critical'],
          selectedRisk: [],
          selectedPolicyError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              selectedPolicyError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddLicense() {
    const {
      selectedLicense, selectedFamily, selectedlicenseName, selectedPolicy
    } = this.state;
    const { translate } = this.props;
    let newObj;

    if (selectedLicense === 'family') {
      const checkUnique = this.state.selectedPolicy.filter((item) => {
        return item.selected[0] === selectedFamily[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          license_condition: selectedLicense,
          selected: selectedFamily,
        };
        this.setState({
          selectedPolicy: [...selectedPolicy, newObj],
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          selectedPolicyError: '',
        });
      } else {
        this.setState({
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          selectedPolicyError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              selectedPolicyError: '',
            });
          }, 1500);
        });
      }
    } else {
      const checkUnique = this.state.selectedPolicy.filter((item) => {
        return item.selected[0] === selectedlicenseName[0];
      });
      if (checkUnique.length === 0) {
        newObj = {
          license_condition: selectedLicense,
          selected: selectedlicenseName,
        };
        this.setState({
          selectedPolicy: [...selectedPolicy, newObj],
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          selectedPolicyError: '',
        });
      } else {
        this.setState({
          selectedLicense: 'family',
          selectedFamily: ['protective'],
          selectedlicenseName: [],
          selectedPolicyError: translate('settings.message.use_condition'),
        }, () => {
          setTimeout(() => {
            this.setState({
              selectedPolicyError: '',
            });
          }, 1500);
        });
      }
    }
  }

  handleAddLitigator() {
    const { selectedLitigator, selectedPolicy } = this.state;
    const { translate } = this.props;
    const checkUnique = this.state.selectedPolicy.filter((item) => {
      return item.selected[0] === selectedLitigator[0];
    });
    if (checkUnique.length === 0) {
      const newObj = {
        selected: selectedLitigator,
      };

      this.setState({
        selectedPolicy: [...selectedPolicy, newObj],
        selectedLitigator: [],
        selectedPolicyError: '',
      });
    } else {
      this.setState({
        selectedLitigator: [],
        selectedPolicyError: translate('settings.message.use_condition'),
      }, () => {
        setTimeout(() => {
          this.setState({
            selectedPolicyError: '',
          });
        }, 1500);
      });
    }
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  addConditionBtn = () => {
    const {
      selectedComponent, selectedCondition, selectedVersion, selectedVersionList
    } = this.state;
    const { translate } = this.props;

    if (selectedCondition === 'all') {
      if (!selectedComponent) {
        return (
          <a
            className="blue_button"
            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
          >
            {translate('modal.button.add')}
          </a>
        );
      }
      return (
        <a
          className="blue_button"
          style={{ cursor: 'pointer' }}
          onClick={this.handleAddCondition}
          onKeyUp={this.handleAddCondition}
        >
          {translate('modal.button.add')}
        </a>
      );
    } if (selectedCondition === 'specific') {
      if (!selectedComponent || selectedVersionList.length === 0) {
        return (
          <a
            className="blue_button"
            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
          >
            {translate('modal.button.add')}
          </a>
        );
      }
      return (
        <a
          className="blue_button"
          style={{ cursor: 'pointer' }}
          onClick={this.handleAddCondition}
          onKeyUp={this.handleAddCondition}
        >
          {translate('modal.button.add')}
        </a>
      );
    } if (!selectedComponent || selectedVersion.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}
        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddCondition}
        onKeyUp={this.handleAddCondition}
      >
        {translate('modal.button.add')}
      </a>
    );
  };

  addSecurityBtn = () => {
    const { selectedSecurity, selectedRisk } = this.state;
    const { translate } = this.props;
    if (selectedSecurity === 'code' && selectedRisk.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddSecurity}
        onKeyUp={this.handleAddSecurity}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  addLicenseBtn = () => {
    const { selectedLicense, selectedlicenseName } = this.state;
    const { translate } = this.props;
    if (selectedLicense === 'name' && selectedlicenseName.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddLicense}
        onKeyUp={this.handleAddLicense}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  addLitigatorBtn = () => {
    const { selectedLitigator } = this.state;
    const { translate } = this.props;
    if (selectedLitigator.length === 0) {
      return (
        <a
          className="blue_button"
          style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
        >
          {translate('modal.button.add')}

        </a>
      );
    }
    return (
      <a
        className="blue_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleAddLitigator}
        onKeyUp={this.handleAddLitigator}
      >
        {translate('modal.button.add')}

      </a>
    );
  };

  clearVersionValue = (value) => {
    const { selectedVersionList } = this.state;
    let newState;

    if (selectedVersionList.indexOf(value) > -1) {
      newState = selectedVersionList.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [];
    }

    if (newState.length === 0) {
      this.setState({
        selectedVersionList: [],
        selectedVersion: [],
      });
    } else {
      this.setState({
        selectedVersionList: newState,
      });
    }
  };

  clearLitigatorValue = (value) => {
    const { selectedLitigatorList } = this.state;
    let newState;

    if (selectedLitigatorList.indexOf(value) > -1) {
      newState = selectedLitigatorList.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [];
    }

    if (newState.length === 0) {
      this.setState({
        selectedLitigatorList: [],
        selectedLitigator: [],
      });
    } else {
      this.setState({
        selectedLitigatorList: newState,
      });
    }
  };

  debounce(func, delay) {
    let timer;
    return function debouncedFunction(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => { return func.apply(this, args); }, delay);
    };
  }

  searchPolicyComponent(searchKeyword) {
    const { limit } = this.state;
    api
      .searchPolicyComponent({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          componentList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchPolicyVersion(searchKeyword) {
    const { limit, selectedComponent, editSearchComponent } = this.state;
    if (!editSearchComponent) {
      api
        .searchPolicyVersion({
          search: searchKeyword || '',
          component: selectedComponent,
          limit,
        })
        .then((response) => {
          if (response.count === 0) return;
          const data = response.response;
          const newData = data.map((item, index) => {
            return {
              key: index,
              text: item,
              value: item,
            };
          });
          this.setState({
            versionList: newData,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      api
        .searchPolicyVersion({
          search: searchKeyword || '',
          component: editSearchComponent,
          limit,
        })
        .then((response) => {
          if (response.count === 0) return;
          const data = response.response;
          const newData = data.map((item, index) => {
            return {
              key: index,
              text: item,
              value: item,
            };
          });
          this.setState({
            versionList: newData,
            editSearchComponent: '',
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  searchPolicyRisk(searchKeyword) {
    const { limit } = this.state;
    api
      .searchPolicyRisk({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          riskList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchPolicyLicense(searchKeyword) {
    const { limit } = this.state;
    api
      .searchPolicyLicense({
        search: searchKeyword || '',
        limit,
      })
      .then((response) => {
        if (response.count === 0) return;
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            key: index,
            text: item,
            value: item,
          };
        });
        this.setState({
          licenseNameList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  isEqual(a, b) {
    const aCnt = a.length;
    const bCnt = b.length;
    let cNt = 0;
    let i = 0;

    if (aCnt !== bCnt) {
      return false;
    }

    for (i; i < aCnt; i++) {
      let j = 0;
      for (j; j < bCnt; j++) {
        if (a[i] === b[j]) {
          cNt++;
          break;
        }
      }
    }

    if (cNt === aCnt && cNt === bCnt) {
      return true;
    }
    return false;
  }

  closeNewPolicyModal(e) {
    if (e) {
      e.preventDefault();
      if (e.target.classList[1] === 'icon' || e.target.classList[1] === 'item' || e.target.classList[0] === 'red_button' || e.target.classList[0] === 'text') {
        return false;
      }
    }
    this.setState({
      isOpenMCP: false,
    });
    this.props.closeModal();
  }

  closeAlertModal() {
    const { translate } = this.props;
    if (this.state.modalAlertTitle.indexOf(translate('modal.title.attention')) > -1) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.props.completeCallback(200);
          this.closeNewPolicyModal();
        }
      );
    }
  }

  divideStr(str) {
    if (str.length > 40) {
      return `${str.substr(0, 36)}...`;
    }
    return str;
  }

  validateFields() {
    const { policyName, selectedPolicy } = this.state;
    const { translate } = this.props;

    const validation = {
      policyName: true,
      condition: true,
    };

    if (policyName.trim().length === 0) {
      this.setState({
        policyNameError: translate('settings.message.required_policy'),
      });
      this.policyNM.scrollIntoView();
      this.nameInput.focus();
      validation.policyName = false;
      return false;
    }
    if (this.getByteLength(policyName) > 30) {
      this.setState({
        policyNameError: translate('settings.message.limite_character_policy'),
      });
      this.policyNM.scrollIntoView();
      this.nameInput.focus();
      validation.policyName = false;
      return false;
    }

    if (selectedPolicy.length === 0) {
      this.setState({
        selectedPolicyError: translate('settings.message.select_one_condition'),
      });
      this.condition.scrollIntoView();
      validation.condition = false;
      return false;
    }

    return validation.policyName && validation.condition;
  }

  renderVersionValue = (value) => {
    return (
      <div
        className="text_box"
        style={{ border: '1px solid #cacaca', boxSizing: 'border-box', borderRadius: '5px' }}
      >
        {this.divideStr(value)}
        <Icon
          name="close"
          style={{
            cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
          }}
          onClick={() => {
            return this.clearVersionValue(value);
          }}
        />
      </div>
    );
  };

  render() {
    const {
      selectedCoverage,
      policyName,
      description,
      category,
      selectedComponent,
      selectedCondition,
      selectedVersion,
      selectedVersionList,
      selectedSecurity,
      componentList,
      versionList,
      selectedSeverity,
      riskList,
      selectedRisk,
      selectedLicense,
      selectedFamily,
      licenseNameList,
      selectedlicenseName,
      selectedLitigator,
      selectedPolicy,
    } = this.state;

    const { translate } = this.props;

    const coverage = [
      { key: 1, text: translate('project.menu.project'), value: 'project' },
      { key: 2, text: translate('contents_header.menu.company'), value: 'company' },
    ];

    const versionConditions = [
      { key: '1', text: translate('settings.list.all_versions'), value: 'all' },
      { key: '2', text: translate('settings.list.and_earlier'), value: 'earlier' },
      { key: '3', text: translate('settings.list.and_later'), value: 'later' },
      { key: '4', text: translate('settings.list.specific_version'), value: 'specific' },
    ];
    const securityConditions = [
      { key: '1', text: translate('settings.list.security_risk_severity'), value: 'severity' },
      { key: '2', text: translate('settings.list.security_risk'), value: 'code' },
    ];
    const severityConditions = [
      { key: '1', text: 'Critical', value: 'critical' },
      { key: '2', text: 'High', value: 'high' },
      { key: '3', text: 'Medium', value: 'medium' },
      { key: '4', text: 'Low', value: 'low' },
    ];
    const licenseConditions = [
      { key: '1', text: translate('list.title.license_family'), value: 'family' },
      { key: '2', text: translate('list.title.license'), value: 'name' },
    ];
    const familyConditions = [
      { key: '1', text: 'Protective', value: 'protective' },
      { key: '2', text: 'Permissive', value: 'permissive' },
      { key: '3', text: 'Others', value: 'others' },
    ];
    const litigatorConditions = [
      { key: '1', text: 'SFC', value: 'sfc' },
      { key: '2', text: 'McHardy', value: 'mchardy' },
      { key: '3', text: 'Patent Module', value: 'patents' },
    ];

    const policyNameErrorClass = this.state.policyNameError !== '' ? 'show' : '';
    const conditionErrorClass = this.state.selectedPolicyError !== '' ? 'show' : '';

    return (
      <Modal open={this.state.isOpenMCP} onClose={this.closeNewPolicyModal}>
        <div className="setting_popup default_popup has_popup_inner_menu">
          <div className="setting_popup_header">
            <h2 className="popup_name">{translate('settings.list.new_policy')}</h2>
            <a
              className="popup_close_button"
              onClick={this.closeNewPolicyModal}
              onKeyUp={this.closeNewPolicyModal}
            >
              <img src={closeBtn} alt="" />
            </a>
            <div className="popup_inner_menu">
              <a className="active" style={{ cursor: 'initial' }}>
                {translate('settings.list.policy_information')}
              </a>
            </div>
          </div>
          <Scrollbars
            style={{
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
            }}
          >
            <div className="setting_popup_contnets">
              <div className="setting_popup_content_wrap">
                <h4 className="content_title">{translate('settings.list.policy_coverage')}</h4>
                <div className="setting_popup_content">
                  <div className="small_box">
                    <Dropdown
                      options={coverage}
                      defaultValue={selectedCoverage}
                      onChange={this.handleCoverageChange}
                      style={{ width: '50%' }}
                    />
                    {selectedCoverage === 'company' && (
                      <Label basic pointing>
                        {translate('settings.message.company_policy')}
                      </Label>
                    )}
                  </div>
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h4
                  className="content_title"
                  ref={(ref) => {
                    this.policyNM = ref;
                  }}
                >
                  {translate('settings.list.policy_name')}
                  <em style={{ marginLeft: '0' }} className="asterisk" />
                </h4>
                <div className="setting_popup_content">
                  <input
                    type="text"
                    placeholder={translate('settings.list.policy_name')}
                    value={policyName}
                    onChange={this.handleNameChange}
                    ref={(ref) => {
                      this.nameInput = ref;
                    }}
                  />
                  <div
                    className={`error ${policyNameErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.policyNameError}
                  </div>
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h4 className="content_title">{translate('list.title.description')}</h4>
                <div className="setting_popup_content">
                  <textarea
                    value={description}
                    placeholder={translate('list.title.description')}
                    onChange={this.handleDescChange}
                    rows="3"
                  />
                </div>
              </div>
              <div className="setting_popup_content_wrap">
                <h4 className="content_title">{translate('settings.list.category')}</h4>
                <div className="setting_popup_content">
                  <div className="small_box">
                    <div className="switch button_4">
                      <a
                        style={{ cursor: 'pointer' }}
                        className={category.indexOf('component') > -1 ? 'checked' : null}
                        onClick={this.handleCategoryChange}
                        onKeyUp={this.handleCategoryChange}
                      >
                        {translate('project.menu.component')}
                      </a>
                      <a
                        style={{ cursor: 'pointer' }}
                        className={category.indexOf('security') > -1 ? 'checked' : null}
                        onClick={this.handleCategoryChange}
                        onKeyUp={this.handleCategoryChange}
                      >
                        {translate('project.menu.security')}
                      </a>
                      <a
                        style={{ cursor: 'pointer' }}
                        className={category.indexOf('license') > -1 ? 'checked' : null}
                        onClick={this.handleCategoryChange}
                        onKeyUp={this.handleCategoryChange}
                      >
                        {translate('project.menu.license')}
                      </a>
                      <a
                        style={{ cursor: 'pointer' }}
                        className={category.indexOf('litigator') > -1 ? 'checked' : null}
                        onClick={this.handleCategoryChange}
                        onKeyUp={this.handleCategoryChange}
                      >
                        {translate('project.menu.litigator')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {category.indexOf('component') > -1 && (
                <div className="setting_popup_content_wrap">
                  <h4
                    className="content_title"
                    ref={(ref) => {
                      this.condition = ref;
                    }}

                  >
                    {translate('settings.list.condition')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h4>
                  <div
                    className={`error ${conditionErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.selectedPolicyError}
                  </div>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '10%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.component_placeholder')}
                              onChange={this.handleComponentChange}
                              onFocus={this.handleComponentSearchChange}
                              onSearchChange={this.handleComponentSearchChange}
                              options={componentList}
                              search
                              selection
                              value={selectedComponent}
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.condition_placeholder')}
                              disabled={selectedComponent === ''}
                              options={versionConditions}
                              value={selectedCondition}
                              onChange={this.handleVersionConditionChange}
                              selection
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.version_placeholder')}
                              disabled={!selectedComponent || selectedCondition === 'all'}
                              onChange={this.handleVersionChange}
                              //onFocus={this.handleVersionSearchChange}
                              onSearchChange={this.handleVersionSearchChange}
                              options={versionList}
                              openOnFocus
                              search
                              selection
                              style={{ width: '330px' }}
                              value={selectedVersion[0]}
                            />
                          </td>
                          <td>
                            {
                              this.addConditionBtn()
                            }
                          </td>
                        </tr>
                        {
                          selectedVersionList.length !== 0 ? (
                            selectedVersionList.map((item) => {
                              return (
                                <tr key={uuidv4()}>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td style={{ paddingTop: '5px' }}>{this.renderVersionValue(item)}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              );
                            })
                          ) : null
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {category.indexOf('security') > -1 && (
                <div className="setting_popup_content_wrap">
                  <h4 className="content_title">
                    {translate('settings.list.condition')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h4>
                  <div
                    className={`error ${conditionErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.selectedPolicyError}
                  </div>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '10%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.security_condition_placeholder')}
                              options={securityConditions}
                              value={selectedSecurity}
                              onChange={this.handleSecurityConditionChange}
                              selection
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.security_condition_placeholder')}
                              disabled={selectedSecurity === 'code'}
                              options={severityConditions}
                              value={selectedSeverity[0]}
                              onChange={this.handleSeverityChange}
                              selection
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.search_risk_placeholder')}
                              onChange={this.handleRiskChange}
                              onFocus={this.handleRiskSearchChange}
                              onSearchChange={this.handleRiskSearchChange}
                              onOpen={this.handleRiskSearchChange}
                              options={riskList}
                              search
                              selection
                              value={selectedRisk[0]}
                              disabled={selectedSecurity === 'severity'}
                            />
                          </td>
                          <td>
                            {
                              this.addSecurityBtn()
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {category.indexOf('license') > -1 && (
                <div className="setting_popup_content_wrap">
                  <h4 className="content_title">
                    {translate('settings.list.condition')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h4>
                  <div
                    className={`error ${conditionErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.selectedPolicyError}
                  </div>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '10%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.license_condition_placeholder')}
                              options={licenseConditions}
                              value={selectedLicense}
                              onChange={this.handleLicenseConditionChange}
                              selection
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.security_condition_placeholder')}
                              disabled={selectedLicense === 'name'}
                              options={familyConditions}
                              value={selectedFamily[0]}
                              onChange={this.handleFamilyChange}
                              selection
                            />
                          </td>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.select_license_placeholder')}
                              onChange={this.handleLicenseNameChange}
                              onFocus={this.handleLicenseNameSearchChange}
                              onSearchChange={this.handleLicenseNameSearchChange}
                              onOpen={this.handleLicenseNameSearchChange}
                              options={licenseNameList}
                              search
                              selection
                              value={selectedlicenseName[0]}
                              disabled={selectedLicense === 'family'}
                            />
                          </td>
                          <td>
                            {
                              this.addLicenseBtn()
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {category.indexOf('litigator') > -1 && (
                <div className="setting_popup_content_wrap">
                  <h4 className="content_title">
                    {translate('settings.list.condition')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h4>
                  <div
                    className={`error ${conditionErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {this.state.selectedPolicyError}
                  </div>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '10%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <Dropdown
                              placeholder={translate('settings.message.select_litigator_placeholder')}
                              options={litigatorConditions}
                              value={selectedLitigator[0]}
                              onChange={this.handleLitigatorConditionChange}
                              selection
                            />
                          </td>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                          <td>
                            {
                              this.addLitigatorBtn()
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="setting_popup_content_wrap" style={{ marginBottom: '100px' }}>
                <h4 className="content_title">{translate('settings.list.selected_condition')}</h4>
                <div className="setting_popup_content">
                  <table className="table">
                    <colgroup>
                      <col style={{ width: '35%' }} />
                      <col style={{ width: '20%' }} />
                      <col style={{ width: '35%' }} />
                      <col style={{ width: '10%' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>{translate('settings.list.condtion_name')}</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                      </tr>
                      {
                        category.indexOf('component') > -1
                        && selectedPolicy.map((item, i) => {
                          if (item.version_condition === 'specific') {
                            return (
                              <tr key={uuidv4()}>
                                <td colSpan="4" style={{ padding: '0', border: 'none' }}>
                                  <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <colgroup>
                                      <col style={{ width: '35%' }} />
                                      <col style={{ width: '20%' }} />
                                      <col style={{ width: '35%' }} />
                                      <col style={{ width: '10%' }} />
                                    </colgroup>
                                    <tbody>
                                      <tr>
                                        <td style={{ paddingTop: '5px' }}>
                                          <div className="edit_box not">
                                            {item.component}
                                          </div>
                                        </td>
                                        <td style={{ paddingTop: '5px' }}>
                                          <div className="edit_box not">
                                            {translate('settings.list.specific')}
                                          </div>
                                        </td>
                                        <td style={{ paddingTop: '5px' }}>
                                          <div
                                            className="edit_box not"
                                          >
                                            {this.divideStr(item.selected_version[0])}
                                            {
                                              item.selected_version.length > 1 ? (
                                                <Icon
                                                  name="close"
                                                  style={{
                                                    cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
                                                  }}
                                                  onClick={() => {
                                                    return this.handleRemoveVersionValue(i, item.selected_version[0]);
                                                  }}
                                                />
                                              ) : null
                                            }
                                          </div>
                                        </td>
                                        <td style={{ paddingTop: '5px' }}>
                                          <a
                                            className="red_button"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              return this.handleRemoveCondition(i);
                                            }}
                                            onKeyUp={() => {
                                              return this.handleRemoveCondition(i);
                                            }}
                                          >
                                            {translate('modal.button.delete')}
                                          </a>
                                        </td>
                                      </tr>
                                      {
                                        item.selected_version.length > 1 ? (
                                          item.selected_version.map((nested, l) => {
                                            if (l > 0) {
                                              return (
                                                <tr key={uuidv4()}>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style={{ paddingTop: '5px' }}>
                                                    <div className="edit_box not">
                                                      {this.divideStr(nested)}
                                                      <Icon
                                                        name="close"
                                                        style={{
                                                          cursor: 'pointer', margin: '0', width: 'inherit', float: 'right'
                                                        }}
                                                        onClick={() => {
                                                          return this.handleRemoveVersionValue(i, item.selected_version[l]);
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td>&nbsp;</td>
                                                </tr>
                                              );
                                            }
                                            return null;
                                          })
                                        ) : null
                                      }
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            );
                          }
                          if (item.version_condition === 'all') {
                            return (
                              <tr key={uuidv4()}>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {item.component}
                                  </div>
                                </td>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {translate('settings.list.all')}
                                  </div>
                                </td>
                                <td style={{ paddingTop: '5px' }}>&nbsp;</td>
                                <td>
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={uuidv4()}>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {item.component}
                                </div>
                              </td>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {item.version_condition === 'earlier' ? 'Earlier' : 'Later' }
                                </div>
                              </td>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {this.divideStr(item.selected_version[0])}
                                </div>
                              </td>
                              <td>
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      }
                      {
                        category.indexOf('security') > -1
                        && selectedPolicy.map((item, i) => {
                          if (item.security_condition === 'severity') {
                            return (
                              <tr key={uuidv4()}>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {
                                      item.security_condition === 'severity' && 'Security Risk Severity'
                                    }
                                    {
                                      item.security_condition === 'code' && 'Security Risk'
                                    }
                                  </div>
                                </td>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {
                                      item.selected[0] === 'critical' && 'Critical'
                                    }
                                    {
                                      item.selected[0] === 'high' && 'High'
                                    }
                                    {
                                      item.selected[0] === 'medium' && 'Medium'
                                    }
                                    {
                                      item.selected[0] === 'low' && 'Low'
                                    }
                                  </div>
                                </td>
                                <td>&nbsp;</td>
                                <td style={{ paddingTop: '5px' }}>
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={uuidv4()}>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {
                                    item.security_condition === 'severity' && 'Security Risk Severity'
                                  }
                                  {
                                    item.security_condition === 'code' && 'Security Risk'
                                  }
                                </div>
                              </td>
                              <td>&nbsp;</td>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {item.selected[0]}
                                </div>
                              </td>
                              <td style={{ paddingTop: '5px' }}>
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      }
                      {
                        category.indexOf('license') > -1
                        && selectedPolicy.map((item, i) => {
                          if (item.license_condition === 'family') {
                            return (
                              <tr key={uuidv4()}>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {
                                      item.license_condition === 'family' && 'License Family'
                                    }
                                    {
                                      item.license_condition === 'name' && 'License'
                                    }
                                  </div>
                                </td>
                                <td style={{ paddingTop: '5px' }}>
                                  <div className="edit_box not">
                                    {
                                      item.selected[0] === 'protective' && 'Protective'
                                    }
                                    {
                                      item.selected[0] === 'permissive' && 'Permissive'
                                    }
                                    {
                                      item.selected[0] === 'others' && 'Others'
                                    }
                                  </div>
                                </td>
                                <td>&nbsp;</td>
                                <td style={{ paddingTop: '5px' }}>
                                  <a
                                    className="red_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                    onKeyUp={() => {
                                      return this.handleRemoveCondition(i);
                                    }}
                                  >
                                    {translate('modal.button.delete')}
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={uuidv4()}>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {
                                    item.license_condition === 'family' && 'License Family'
                                  }
                                  {
                                    item.license_condition === 'name' && 'License'
                                  }
                                </div>
                              </td>
                              <td>&nbsp;</td>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {item.selected[0]}
                                </div>
                              </td>
                              <td style={{ paddingTop: '5px' }}>
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      }
                      {
                        category.indexOf('litigator') > -1
                        && selectedPolicy.map((item, i) => {
                          return (
                            <tr key={uuidv4()}>
                              <td style={{ paddingTop: '5px' }}>
                                <div className="edit_box not">
                                  {
                                    item.selected[0] === 'mchardy' && 'McHardy'
                                  }
                                  {
                                    item.selected[0] === 'sfc' && 'SFC'
                                  }
                                  {
                                    item.selected[0] === 'patents' && 'Patent Module'
                                  }
                                </div>
                              </td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td style={{ paddingTop: '5px' }}>
                                <a
                                  className="red_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                  onKeyUp={() => {
                                    return this.handleRemoveCondition(i);
                                  }}
                                >
                                  {translate('modal.button.delete')}
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Scrollbars>
          <div className="setting_popup_button_wrap">
            <a
              className="button cencel_button"
              style={{ cursor: 'pointer' }}
              onClick={this.closeNewPolicyModal}
              onKeyUp={this.closeNewPolicyModal}

            >
              {translate('modal.button.cancel')}
            </a>
            <a
              className="button save_button"
              style={{ cursor: 'pointer' }}
              onClick={this.handleSave}
              onKeyUp={this.handleSave}
            >
              {translate('modal.button.save')}
            </a>
          </div>
        </div>
        <Modal open={this.state.modalAlert} onClose={this.closeAlertModal}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.closeAlertModal}
                      onKeyUp={this.closeAlertModal}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}

export default inject('state')(observer(NewPolicyModal));
